module.exports = __webpack_public_path__ + "static/media/ge.292fa458.svg";